import { memo, useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Toast, Popover } from 'reaxl';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { sendImpressions, sendClick } from 'reaxl-analytics';
import { myWalletNonDealNotificationsImpression, seeDetailsGlobalNavDealImpression, myWalletNonDealNotificationsClick, seeDetailsGlobalNavDealClick } from 'reaxl-analytics-handlers';
import { WALLET_UPDATE_DEAL_NOTIFICATION_REQUEST } from 'wallet-manager';
import { eventBus } from '@atc/cai-event-bus';
import { jsx, jsxs } from 'react/jsx-runtime';
import getPopoverData from './helpers/getPopoverData.js';
import getLocationMessage from './helpers/getLocationMessage.js';
const WalletHeaderPopover = /*#__PURE__*/memo(_ref => {
  let {
    onClick,
    onCloseClick = () => {},
    hasNewTradeIn,
    dealNotifications,
    dealDetails = {},
    paymentsDuck,
    dealsDuck,
    uiContext = 'popover',
    position = 'top'
  } = _ref;
  const dispatch = useDispatch();
  const [showWalletAlert, setShowWalletAlert] = useState(true);
  const sentImpression = useRef(false);
  const popoverData = getPopoverData(hasNewTradeIn, dealNotifications, dealDetails);
  useEffect(() => {
    const isNonDeal = popoverData?.dealReminders?.length > 0;
    const showPopover = !(uiContext === 'alert' && showWalletAlert);
    if (!sentImpression.current && showPopover && !_isEmpty(popoverData)) {
      sentImpression.current = true;
      if (isNonDeal) {
        sendImpressions({
          name: myWalletNonDealNotificationsImpression,
          data: {
            textContent: popoverData.label
          }
        });
      } else {
        sendImpressions({
          name: seeDetailsGlobalNavDealImpression,
          data: {
            location: getLocationMessage(hasNewTradeIn, dealNotifications)
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popoverData]);
  const handlePopoverLinkClick = e => {
    const dealReminders = popoverData?.dealReminders;
    const isNonDeal = dealReminders?.length > 0;
    if (isNonDeal) {
      // the non-deals notif tagging was required to inherit the pageData
      // picks the first deal that caused the notif as initial logic
      const nonDealData = {
        textContent: e.target.textContent,
        vehicle: dealDetails?.[popoverData.deal.dealXgId]?.vehicle
      };
      dealReminders?.forEach(_ref2 => {
        let {
          dealId,
          updateKey
        } = _ref2;
        eventBus.emit(WALLET_UPDATE_DEAL_NOTIFICATION_REQUEST, {
          dealId,
          body: {
            [updateKey]: true
          }
        });
        dispatch(dealsDuck?.creators?.updateDealReminders({
          dealId,
          [updateKey]: true
        }));
      });
      sendClick(myWalletNonDealNotificationsClick, e, nonDealData);
    } else {
      sendClick(seeDetailsGlobalNavDealClick, e, {
        location: getLocationMessage(hasNewTradeIn, dealNotifications)
      });
    }
    onClick(e);
    onCloseClick();
    setShowWalletAlert(false);
  };
  const handlePopoverCloseClick = () => {
    onCloseClick();
    setShowWalletAlert(false);
  };
  if (!_isEmpty(popoverData)) {
    if (uiContext === 'alert' && showWalletAlert) {
      return /*#__PURE__*/jsx(Alert, {
        bsStyle: "info",
        onDismiss: handlePopoverCloseClick,
        children: /*#__PURE__*/jsxs("div", {
          className: "display-flex",
          children: [/*#__PURE__*/jsx("div", {
            className: "text-bold margin-right-1",
            children: popoverData.message
          }), ' ', /*#__PURE__*/jsx(Button, {
            bsStyle: "link",
            className: "padding-0 border-0",
            "data-panel": popoverData.panel,
            onClick: handlePopoverLinkClick,
            children: popoverData.label || 'See Details'
          })]
        })
      });
    }
    if (uiContext === 'toast') {
      return /*#__PURE__*/jsx(Toast, {
        show: true,
        uiContext: "info",
        speed: "slow",
        position: position,
        heading: "My Wallet Alert!",
        body: /*#__PURE__*/jsxs("div", {
          children: [popoverData.message, /*#__PURE__*/jsx(Button, {
            bsStyle: "text-decorated-inverse",
            className: "padding-0 border-0",
            "data-panel": popoverData.panel,
            onClick: handlePopoverLinkClick,
            children: popoverData.label || 'See Details'
          })]
        })
      });
    }
    return /*#__PURE__*/jsx(Popover, {
      id: "header-wallet-popover",
      className: "margin-top-3 header-wallet-popover",
      placement: "bottom",
      onCloseClick: handlePopoverCloseClick,
      children: /*#__PURE__*/jsxs("div", {
        children: [popoverData.message, ' ', /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(Button, {
            bsStyle: "link",
            className: "padding-0 border-0",
            "data-panel": popoverData.panel,
            onClick: handlePopoverLinkClick,
            children: popoverData.label || 'See Details'
          })
        })]
      })
    });
  }
  return null;
}, (prevProps, nextProps) => _isEqual(prevProps, nextProps));
export { WalletHeaderPopover as default };
